import type { ComponentTypes } from 'types/selectComponent'
import type { FilterComponentNode, FilterComponentRendererType, FilterGenericPropsType } from '../type'
import SystemCompatibilityFilter, { FilterOptionsType } from './SystemCompatibilityFilter'

export const SYSTEM_COMPATIBILITY_FILTER_NODE_KEY = 'battery_compatibility'
export const BATTERY_COMPATIBILITY_FILTER_KEY = 'codes'
export const SYSTEM_COMPATIBILITY_FILTER_KEY = 'system_compatibility'

const maybeCreateSystemCompatibilityFilterNode = ({
  RendererComponent,
  componentType,
}: {
  RendererComponent: FilterComponentRendererType<FilterOptionsType>
  componentType?: ComponentTypes
}): FilterComponentNode | undefined => {
  if (componentType !== 'battery') {
    return undefined
  }

  const FilterComponent = (props: FilterGenericPropsType) => {
    return (
      <SystemCompatibilityFilter
        id={SYSTEM_COMPATIBILITY_FILTER_NODE_KEY}
        filterKey={componentType === 'battery' ? BATTERY_COMPATIBILITY_FILTER_KEY : SYSTEM_COMPATIBILITY_FILTER_KEY}
        RendererComponent={RendererComponent}
        componentType={componentType}
        {...props}
      />
    )
  }
  return {
    key: SYSTEM_COMPATIBILITY_FILTER_NODE_KEY,
    component: FilterComponent,
  }
}

export default maybeCreateSystemCompatibilityFilterNode
